import React from "react";

import ConsignmentList from "../consignmentList";

const ConsignmentListSent = () => <ConsignmentList sentList />;

export default ConsignmentListSent;
